import api from '../api/api';

// services
import { authApi } from '../hoc/store/services';

// reducers
import authReducer from '../hoc/store/slice';

export { authApi, authReducer };

export const authMiddlewares = authApi;

export const authReducers = {
  authApi: api.reducer,
  auth: authReducer,
};
